import React, { useEffect, useState } from "react";
import MainComponent from "../MainComponent";
import { useNavigate } from "react-router-dom";
import { motion } from "motion/react";
import Login from "../Login";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { getReportAnalytics } from "../../store/actions";
import ColouredTabIcon from "../../assets/images/coloured-tab-icon.svg";
const ProjectAnalytics = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [projectData, setProjectData] = useState([]);
  const [expand, setExpand] = useState(false);
  const fecthGetReportAnalyticsData = useSelector(
    (state) => state.fecthGetReportAnalyticsData
  );

  const handleBack = () => {
    navigate("/executionplansummary", { replace: true });
  };

  const handleClick = () => {
    navigate("/ganttchart", { replace: true });
  };
  useEffect(() => {
    dispatch(getReportAnalytics(localStorage.getItem("screen_id")));
  }, []);
  useEffect(() => {
    if (fecthGetReportAnalyticsData) {
      setProjectData(fecthGetReportAnalyticsData.data);
    }
  }, [fecthGetReportAnalyticsData]);
  const handleExpand = () => {
    setExpand(true);
    const url = `/projectanalytics/expandview/`;
    const newTab = window.open(url, "_blank");
    newTab.focus();
  };
  const content = (
    <>
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
        className="projectsummary"
      >
        <div
          style={{
            fontSize: "var(--main-heading)",
            fontWeight: "var(--heading-font-weight)",
          }}
        >
          Project Analytics
          <span onClick={() => handleExpand()}>
            <img
              src={ColouredTabIcon}
              style={{
                width: "20px",
                height: "20px",
                marginLeft: "10px",
                cursor: "pointer",
              }}
            />
          </span>
        </div>
        {projectData && projectData?.length > 0 && (
          <Tabs
            defaultActiveKey={projectData[0].tab_title}
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            {projectData.map((project) => (
              <Tab
                eventKey={project.tab_title}
                title={project.tab_title}
                key={project.tab_title}
              >
                <div
                  style={{ height: "70vh" }}
                  dangerouslySetInnerHTML={{ __html: project.embedcode }}
                />
              </Tab>
            ))}
          </Tabs>
        )}
      </motion.div>
    </>
  );
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <MainComponent
        maincontent={content}
        showSelector={false}
        showButtons={true}
        showTemplate={true}
        handleNext={handleClick}
        handleBackButton={handleBack}
        breadcrumbParent={"Reports"}
        breadcrumbChild={"Project Analytics"}
        documentName={"Project Analytics"}
        image={"none"}
      />
    );
  }
};

export default ProjectAnalytics;

export const ExpandProjectAnalytics = () => {
  const dispatch = useDispatch();
  const [projectData, setProjectData] = useState([]);
  const fecthGetReportAnalyticsData = useSelector(
    (state) => state.fecthGetReportAnalyticsData
  );
  useEffect(() => {
    dispatch(getReportAnalytics(localStorage.getItem("screen_id")));
  }, []);
  useEffect(() => {
    if (fecthGetReportAnalyticsData) {
      setProjectData(fecthGetReportAnalyticsData.data);
    }
  }, [fecthGetReportAnalyticsData]);
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <>
        {projectData && projectData?.length > 0 && (
          <Tabs
            defaultActiveKey={projectData[0].tab_title}
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            {projectData.map((project) => (
              <Tab
                eventKey={project.tab_title}
                title={project.tab_title}
                key={project.tab_title}
              >
                <div
                  style={{ height: "90vh" }}
                  dangerouslySetInnerHTML={{ __html: project.embedcode }}
                />
              </Tab>
            ))}
          </Tabs>
        )}
      </>
    );
  }
};
